<template>
    <div
        v-if="checkShowStatus"
        class="font-bold">
        <span v-if="CLable">
            {{ CLable }}:
        </span>

        <span
            v-if="getObjectStatus.label"
            :class="getObjectStatus.class"
            class="font-medium mr-2 dark:bg-blue-900 dark:text-blue-300 shadow-lg select-none">
            <span>
                {{ getObjectStatus.label || '' }}
            </span>
            <template v-if="['active'].includes(CStatus)">
                <span class="ml-1">
                    {{ freightekInvoiceCode }}
                </span>
            </template>
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object,
  status: {
    type: [String, Number]
  },
  size: {
    type: String,
    default: 'default'
  },
  label: {
    type: String,
    default: ''
  },
  keyStatus: {
    type: String
  }
})

const { params, status, size, label, keyStatus } = toRefs(props)
const freightekInvoiceCode = computed(() => {
  if (!params?.value?.data) {
    return ''
  }
  return params?.value?.data?.freightekInvoiceCode
})
const checkShowStatus = computed(() => {
  if (!params?.value?.check) {
    return true
  }
  return params?.value.check(params?.value?.data)
})

const CKeyStatus = computed(() => {
  return params?.value?.keyStatus || keyStatus?.value
})

const CStatus = computed(() => {
  if (params?.value && CKeyStatus.value) {
    return params?.value?.data?.[CKeyStatus.value]
  }

  if (typeof params?.value?.data?.status === 'number') {
    return params.value.data.status
  }

  if (typeof status?.value === 'number') {
    return status.value
  }
  return null
})

const CSize = computed(() => {
  return params?.value?.size || size?.value
})

const CLable = computed(() => {
  if (typeof params?.value?.label === 'string') {
    return params?.value?.label
  }
  return label.value
})

const invoiceStatus: { [key: string]: any } = {
  pending: {
    label: 'Chờ xác nhận',
    class: 'bg-yellow-100 text-yellow-800'
  },
  active: {
    label: 'Xác nhận',
    class: 'bg-green-100 text-green-800'
  },
  sent: {
    label: 'Đã gửi',
    class: 'bg-blue-100 text-blue-800'
  },
  partial: {
    label: 'Thanh toán một phần',
    class: 'bg-purple-100 text-purple-800'
  },
  paid: {
    label: 'Đã thanh toán',
    class: 'bg-green-100 text-green-800'
  },
  overdue: {
    label: 'Quá hạn',
    class: 'bg-red-100 text-red-800'
  },
  partialOverdue: {
    label: 'Quá hạn một phần',
    class: 'bg-orange-100 text-orange-800'
  }
}

const getObjectStatus = computed(() => {
  const status = CStatus.value

  const classT = invoiceStatus[String(status)] || {}
  if (CSize.value === 'default') {
    classT.class += ' text-sm px-2.5 py-0.5 rounded'
  }
  if (CSize.value === 'medium') {
    classT.class += ' text-[14px] font-medium p-[6px] py-0.5 rounded'
  }
  if (CSize.value === 'large') {
    classT.class += ' text-[18px] font-medium mr-2 p-[8px] rounded-xl'
  }
  return classT
})
</script>

<style scoped></style>
